import {
  outerHeight
} from '../functions/utils';

export default class Collapse {
  constructor(element, optionalContainer = document) {
    this.passedElement = element;
    this.optionalContainer = optionalContainer;
    this.state = {
      collapsed: true
    }
    this.init();
  }

  init() {
    if (!this.initialised) {
      this.initialised = true;
      this._createCollapse();
      this._addEventListeners();
    }
  }

  openCollapse = () => {
    let otherCollapses = INSTANCES["collapses"];

    for (let [key, collapseObject] of Object.entries(otherCollapses)) {
      if (collapseObject.state.collapsed === false) {
        collapseObject.closeCollapse();
      }
    }

    this.collapseTarget.style.height = `${this.collapseTargetInnerHeight}px`;
    this.collapseToggle.setAttribute('aria-expanded', 'true');
    this.state.collapsed = false;
  }

  closeCollapse = () => {
    this.collapseTarget.style.overflow = "hidden";
    this.collapseTarget.style.height = `${0}px`;
    this.collapseToggle.setAttribute('aria-expanded', 'false');
    this.state.collapsed = true;
  }


  _createCollapse = () => {
    const collapseToggle = this.passedElement;
    const collapseTarget = collapseToggle.tagName === 'A' ? this.optionalContainer.querySelector(`${collapseToggle.getAttribute('href')}[data-is="collapsable"]`) : this.optionalContainer.querySelector(`${collapseToggle.getAttribute('data-target')}[data-is="collapsable"]`);

    if (!collapseTarget) {
      console.error('Collapse: target not defined.');
      return false;
    }

    this.collapseToggle = collapseToggle;
    this.collapseTarget = collapseTarget;
    this.collapseTargetInnerHeight = this._getTargetInnerHeight();
  }

  _addEventListeners = () => {
    this.collapseToggle.addEventListener('click', this._onToggleClick);
    this.collapseTarget.addEventListener("transitionend", this._onTransitionEnd);
    window.addEventListener('resize', this._onWindowResize);
  }

  removeEventListeners = () => {
    this.collapseToggle.removeEventListener('click', this._onToggleClick);
    this.collapseTarget.removeEventListener("transitionend", this._onTransitionEnd);
    window.removeEventListener('resize', this._onWindowResize);
  }

  _onToggleClick = (e) => {

    if (this.collapseToggle.tagName === 'A') {
      e.preventDefault();
    }
    if (this.state.collapsed) {
      this.openCollapse();
    } else {
      this.closeCollapse();
    }
  }

  _onTransitionEnd = () => {
    if (!this.state.collapsed) {
      this.collapseTarget.style.overflow = "visible";
    }
  }

  _onWindowResize = () => {
    this.collapseTargetInnerHeight = this._getTargetInnerHeight();
    if (!this.state.collapsed) {
      this.collapseTarget.style.height = `${this.collapseTargetInnerHeight}px`;
    }
  }

  _getTargetInnerHeight = () => {
    let height = 0;
    // If no children return height as 0
    if (!this.collapseTarget.children.length) {
      console.log('Collapse: target has no children.');
      return height;
    }

    if (this.collapseTarget.children.length === 1) {
      height = parseFloat(getComputedStyle(this.collapseTarget.children[0], null).height.replace("px", ""));
    } else {
      Array.from(this.collapseTarget.children).forEach((child, i) => {
        height += parseFloat(getComputedStyle(child, null).height.replace("px", ""));
      });
    }

    return height;
  }

  dismantle = () => {
    this.removeEventListeners();
    this.collapseToggle = null;
    this.collapseTarget = null;
    this.collapseTargetInnerHeight = null;
    this.initialised = false;
  }
}
